export enum TaskActivityType {
  CALL = 'call',
  MEETING = 'meeting',
  SITE_VISIT = 'siteVisit',
  OTHER = 'other',
}

export enum TaskStatus {
  PENDING = 'pending',
  COMPLETED = 'completed',
  CANCELLED = 'cancelled',
  OVERDUE = 'overdue',
}

export enum CallStatus {
  SCHEDULED = 'scheduled',
  FOLLOW_UP = 'followUp',
  REMINDER = 'reminder',
}
